import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

const Index = lazy(() => import("./pages/Index"));
const Bulletin = lazy(() => import("./pages/Bulletin"));
const Home = lazy(() => import("./pages/Home"));
const Clavstore = lazy(() => import("./pages/Clavstore"));
const ClavstoreGulf = lazy(() => import("./pages/ClavstoreGulf"));
const ClavstoreFrench = lazy(() => import("./pages/ClavstoreFrench"));
const Dedicated = lazy(() => import("./pages/Dedicated"));
const MultipleStore = lazy(() => import("./pages/MultipleStore"));
const ClavstoreMultipleStore = lazy(
  () => import("./pages/ClavstoreMultipleStore"),
);
const Reseller = lazy(() => import("./pages/Reseller"));
const ResellerBooked = lazy(() => import("./pages/ResellerBooked"));
const GroupChat = lazy(() => import("./pages/GroupChat"));
const Prime = lazy(() => import("./pages/Prime"));
const Repository = lazy(() => import("./pages/Repository"));
const Upgrades = lazy(() => import("./pages/Upgrades"));
const ClavstoreUpgrades = lazy(() => import("./pages/ClavstoreUpgrades"));
const Grocery = lazy(() => import("./pages/Grocery"));
const Single = lazy(() => import("./pages/Single"));
const DedicatedThankYou = lazy(() => import("./pages/DedicatedThankYou"));

const Article1 = lazy(() => import("./pages/article/Article1"));

const Post1 = lazy(() => import("./pages/post/Post1"));
const Post2 = lazy(() => import("./pages/post/Post2"));
const Post3 = lazy(() => import("./pages/post/Post3"));
const Post4 = lazy(() => import("./pages/post/Post4"));
const Post5 = lazy(() => import("./pages/post/Post5"));
const Post6 = lazy(() => import("./pages/post/Post6"));
const Post7 = lazy(() => import("./pages/post/Post7"));
const Post8 = lazy(() => import("./pages/post/Post8"));
const Post9 = lazy(() => import("./pages/post/Post9"));
const Post10 = lazy(() => import("./pages/post/Post10"));
const Post11 = lazy(() => import("./pages/post/Post11"));
const Post12 = lazy(() => import("./pages/post/Post12"));

const Sales1 = lazy(() => import("./pages/sales/Sales1"));
const Sales2 = lazy(() => import("./pages/sales/Sales2"));
const Sales3 = lazy(() => import("./pages/sales/Sales3"));
const Sales4 = lazy(() => import("./pages/sales/Sales4"));
const Sales5 = lazy(() => import("./pages/sales/Sales5"));
const Sales6 = lazy(() => import("./pages/sales/Sales6"));
const Sales7 = lazy(() => import("./pages/sales/Sales7"));
const Sales8 = lazy(() => import("./pages/sales/Sales8"));

const Guide = lazy(() => import("./pages/Guide"));
const ClavstoreGuide = lazy(() => import("./pages/ClavstoreGuide"));

function App() {
  return (
    <Suspense fallback={<div style={{ padding: 16 }}>Loading page...</div>}>
      <Routes>
        <Route exact path="/" element={<Index />} />
        <Route exact path="/bulletin" element={<Bulletin />} />
        <Route exact path="/cosmic-clavstore" element={<Home />} />
        <Route exact path="/clavstore" element={<Clavstore />} />
        <Route exact path="/clavstore-gulf" element={<ClavstoreGulf />} />
        <Route exact path="/clavstore-french" element={<ClavstoreFrench />} />
        <Route exact path="/dedicated" element={<Dedicated />} />
        <Route exact path="/multiple" element={<MultipleStore />} />
        <Route
          exact
          path="/clavstore-multiple"
          element={<ClavstoreMultipleStore />}
        />
        <Route exact path="/reseller" element={<Reseller />} />
        <Route exact path="/reseller-booked" element={<ResellerBooked />} />
        <Route exact path="/group-chat" element={<GroupChat />} />
        <Route exact path="/prime" element={<Prime />} />
        <Route exact path="/repository" element={<Repository />} />
        <Route exact path="/upgrades" element={<Upgrades />} />
        <Route
          exact
          path="/clavstore-upgrades"
          element={<ClavstoreUpgrades />}
        />
        <Route exact path="/grocery" element={<Grocery />} />
        <Route exact path="/single" element={<Single />} />
        <Route
          exact
          path="/dedicated-thankyou"
          element={<DedicatedThankYou />}
        />

        <Route exact path="/build-customize-app" element={<Article1 />} />

        <Route exact path="/14-minutes-become-expert" element={<Post1 />} />
        <Route exact path="/import-export" element={<Post2 />} />
        <Route exact path="/category-variant-payment" element={<Post3 />} />
        <Route exact path="/tindahan-test-run" element={<Post4 />} />
        <Route exact path="/personal-vs-admin" element={<Post5 />} />
        <Route exact path="/install-mobile-app" element={<Post6 />} />
        <Route exact path="/how-to-use-the-app" element={<Post7 />} />
        <Route exact path="/test-drive-the-app" element={<Post8 />} />
        <Route exact path="/offline-pos-system" element={<Post9 />} />
        <Route exact path="/the-10000-peso-mistake" element={<Post10 />} />
        <Route exact path="/the-wedding-disaster" element={<Post11 />} />
        <Route exact path="/back-to-cosmic-account" element={<Post12 />} />

        <Route exact path="/unlimited-products" element={<Sales1 />} />
        <Route exact path="/need-domain-name" element={<Sales2 />} />
        <Route exact path="/unlimited-date-range" element={<Sales3 />} />
        <Route exact path="/orders-per-page" element={<Sales4 />} />
        <Route exact path="/inventory-per-page" element={<Sales5 />} />
        <Route exact path="/sales-per-page" element={<Sales6 />} />
        <Route exact path="/location-per-page" element={<Sales7 />} />
        <Route exact path="/more-wholesale-level" element={<Sales8 />} />

        <Route exact path="/guide" element={<Guide />} />
        <Route exact path="/guide/:videoid" element={<Guide />} />
        <Route exact path="/clavstore-guide" element={<ClavstoreGuide />} />
        <Route
          exact
          path="/clavstore-guide/:videoid"
          element={<ClavstoreGuide />}
        />
      </Routes>
    </Suspense>
  );
}

export default App;
